<template>
  <section class="container mt-5" aria-label="hero">
    <Breadcrumbs :items="Breadcrumbs" />
    <div class="header-wrapper">
          <div class="experience-title-container">
            <img :src="experience.iconName" class="experience-icon" :alt="experience.imageAltText" role="presentation" />
            <h1 class="experience-title">{{ experience.title }}</h1>
          </div>
          <p v-if="slug === 'alabama-restaurant-week'" class="experience-content-arw mobile-padding"
            data-swiftype-name="body" data-swiftype-type="text">
            {{ experience.content }}
          </p>
          <p v-else class="experience-content" data-swiftype-name="body" data-swiftype-type="text">{{
            experience.content }}</p>
    </div>
  </section>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator';
import Breadcrumbs from '../../Common/Breadcrumbs.vue';

@Component({
  components: {
    Breadcrumbs,
  },
})
class ExperienceDetailHeader extends Vue {
  @Prop({
    type: [Object],
    required: true,
  })
  experience;

  @Prop({
    type: String,
  })
  slug;

  @Prop({ type: Array })
  Breadcrumbs;
}

export default ExperienceDetailHeader;
</script>

<style lang="scss" scoped>
.experience-title-container {
  display: grid;
  gap: var(--spacing-l);
  justify-items: center;

  @media only screen and (min-width: 769px) {
    align-items: center;
    grid-auto-flow: column;
    justify-content: center;
  }
}

.experience-icon {
  height: 75px;
  vertical-align: baseline;
  width: 75px;
}

.experience-title {
  align-items: center;
  font-size: 48px;
  justify-content: center;
  line-height: 105%;

  @media only screen and (min-width: 769px) {
    max-width: 580px;
  }
}

.header-wrapper {
  display: grid;
  gap: var(--spacing-l);
}

.experience-content-arw {
  font-family: 'IdealSans-Book', 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 18px;

  @media only screen and (min-width: 769px) {
    margin-top: var(--spacing-l);
    text-align: center;
  }
}

.experience-content {
  font-family: 'IdealSans-Book', 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 1.125rem;
  text-align: center;
}
</style>
